import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import ParaJumble from './Components/ParaJumble/Parajumble';
import Home from './Components/HomeScreen';
import MentalMathPractice from './Components/MentalMathPractice';
import NumberFactsExplorer from './Components/NumberFacts';
import ApiTest from './Components/Intelligence/testApi';

export default function App() {

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={<Home items={[{name:"Para Jumble",path:"para"},{name:"Table",path:"table"},{name:"Number Facts",path:"facts"},{name:"Api Test",path:""}]} />}
        />
      </Routes>
      <Routes>
        <Route
          path="/para"
          element={<ParaJumble />}
        />
      </Routes>
      <Routes>
        <Route
          path="/table"
          element={<MentalMathPractice />}
        />
      </Routes>
      <Routes>
        <Route
          path="/facts"
          element={<NumberFactsExplorer />}
        />
      </Routes>
    </Router>
  );
}

